/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
// require('js-storage');
require('../../recrmv1/plugins/jquery.i18n');
require('../../recrmv1/js/jquery.serialize-object');
require("jquery-slimscroll");
require("node-waves");
require("jquery-number");
require("offline-js");
require('../../recrmv1/plugins/jquery-comments/js/jquery-comments');
require("jquery-textcomplete");
require("jscroll");
require("bootstrap-notify");
require("daterangepicker");
window.intlTelInput = require("intl-tel-input");
window.Twilio = require('@twilio/voice-sdk');
window.Swal = require('sweetalert2');

// import 'flag-icon-css/css/flag-icon.css';




// require('jszip');
// require('pdfmake');
// require('datatables.net-bs4')();
// require('datatables.net-autofill-bs4')();
// require('datatables.net-buttons-bs4')();
// require('datatables.net-buttons/js/buttons.colVis.js')();
// require('datatables.net-buttons/js/buttons.flash.js')();
// require('datatables.net-buttons/js/buttons.html5.js')();
// require('datatables.net-buttons/js/buttons.print.js')();
// require('datatables.net-colreorder-bs4')();
// require('datatables.net-fixedcolumns-bs4')();
// require('datatables.net-fixedheader-bs4')();
// require('datatables.net-keytable-bs4')();
// require('datatables.net-responsive-bs4')();
// require('datatables.net-rowgroup-bs4')();
// require('datatables.net-rowreorder-bs4')();
// require('datatables.net-scroller-bs4')();
// require('datatables.net-searchpanes-bs4')();
// require('datatables.net-select-bs4')();
// require("yadcf");

// window.dt = require('datatables.net')(window, $);

$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    
    // Simple 419 error handling - just redirect to login without cache clearing
    $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
        if (jqxhr.status === 419 || jqxhr.status === 401) {
            console.log('Session expired, redirecting to login');
            window.location.href = '/login';
        }
    });

    // Retry pending push subscription if user is logged in
    $(document).ready(function() {
        if (typeof window.retryPendingPushSubscription === 'function') {
            window.retryPendingPushSubscription();
        }
    });
    
    function setupTwilioDevice(token) {
        const device = new Twilio.Device(token, {});
        
        // Register event handlers on the device instance
        device.on('incoming', function(call) {
            console.log(call);
            $("#incoming_call_modal #call_progress_div").show();
            $("#incoming_call_modal #call_from").text(call.parameters.From);
            $("#incoming_call_modal").modal({
                backdrop: 'static',
                keyboard: false
            });
            var answerButton = $("#incoming_call_modal_body").find('#acceptcall');
            var rejectButton = $("#incoming_call_modal_body").find('#rejectcall');
            answerButton.click(function() {
                call.accept();
            });
            rejectButton.click(function() {
                call.reject();
            });
        });

        device.on('connect', function(call) {
            $.ajax({
                url: "/twilio/getcallingmodal",
                type: 'GET',
                success: function (data) {
                    $("#incoming_call_modal_body").html(data.form);
                    $("#incoming_call_modal_body #callsid").val(call.parameters.CallSid);
                    window.timerinterval = setInterval(startincomingcalltimer, 1000);
                },
                error: function (data) {
                    console.log(data.responseJSON.errors);
                }
            });
        });

        device.on('disconnect', function(call) {
            $("#incoming_call_modal").modal('hide');
        });

        return device;
    }

    var token = '';
    if (localStorage.getItem("tokenobj"+window.UID) !== null) {
        var jsonString = localStorage.getItem("tokenobj"+window.UID);
        var tokenobj = JSON.parse(jsonString);
        var tokentime = tokenobj.time;
        var token = tokenobj.token;
        var curtime = new Date().getTime();
        var timediff = Math.abs(Math.round((tokentime-curtime)/60000));
        if(timediff >= 50){
            token = '';
        } else {
            setupTwilioDevice(token);
        }
    }
    
    if(token == '' && window.twilio_enable == '1'){
        $.ajax({
            url: "/twilio/generatetoken",
            type: 'GET',
            success: function (data) {
                setupTwilioDevice(data.token);
                var tokenobj = { token: data.token, time: new Date().getTime()};
                var key = "tokenobj"+window.UID;
                localStorage.setItem(key , JSON.stringify(tokenobj));
            },
            error: function (data) {
                console.log(data.responseJSON.errors);
            }
        });
    }
});

// Remove the old event handlers since they're now inside setupTwilioDevice

